var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 3.10938L26.1777 7.77604V9.3316H24.6429C24.6429 9.54225 24.561 9.72454 24.3971 9.87847C24.2332 10.0324 24.0394 10.1094 23.8156 10.1094H5.51769C5.29387 10.1094 5.10002 10.0324 4.93614 9.87847C4.77227 9.72454 4.69033 9.54225 4.69033 9.3316H3.15552V7.77604L14.6666 3.10938ZM6.22515 10.8872H9.29478V20.2205H10.8296V10.8872H13.8992V20.2205H15.434V10.8872H18.5037V20.2205H20.0385V10.8872H23.1081V20.2205H23.8156C24.0394 20.2205 24.2332 20.2975 24.3971 20.4514C24.561 20.6053 24.6429 20.7876 24.6429 20.9983V21.776H4.69033V20.9983C4.69033 20.7876 4.77227 20.6053 4.93614 20.4514C5.10002 20.2975 5.29387 20.2205 5.51769 20.2205H6.22515V10.8872ZM25.3504 22.5538C25.5742 22.5538 25.7681 22.6308 25.9319 22.7847C26.0958 22.9387 26.1777 23.1209 26.1777 23.3316V24.8872H3.15552V23.3316C3.15552 23.1209 3.23745 22.9387 3.40133 22.7847C3.5652 22.6308 3.75905 22.5538 3.98288 22.5538H25.3504Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.854b81e8723e7fd5e56050eef8783cf4.svg";
export { ForwardRef as ReactComponent };